import { useState } from "react";

import { FilterDefinitionType, FilterType } from "@/components/@types";
import { useFilterChipMutations } from "@/components/organisms/UtilityBar/FilterChip/FilterChipStateContext";
import { Input } from "@/components/ui/input";

export function FilterChipValuePickerForText({
  filter,
  filterIndex,
  filterDefinition,
  onChange,
  setIsOpen,
}: {
  filter: FilterType;
  filterIndex: number;
  filterDefinition: FilterDefinitionType;
  onChange: any;
  setIsOpen: any;
}) {
  if (filter.type !== "text") {
    return <></>;
  }

  const [value, setValue] = useState(filter.value);
  const { updateFilterAtIndex } = useFilterChipMutations();

  return (
    <Input
      value={(value as string) || ""}
      placeholder={`enter ${filterDefinition.type}...`}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          // blur the input
          e.currentTarget.blur();
        }
      }}
      onBlur={() => {
        setIsOpen(false);
        updateFilterAtIndex(filterIndex, (current) => ({
          ...current,
          value,
        }));
      }}
      data-testid={`filter-value-input-${filterDefinition.name}`}
    />
  );
}
